import { TeamRepository } from "./TeamRepository";
import { TeamRepositoryInMemory } from "./TeamRepositoryInMemory";

export class TeamRepositoryBuilder {
  build(): TeamRepository {
    return new TeamRepositoryInMemory();
  }
}